import PropTypes from "prop-types"
import { Alert } from "@mui/material"
import { useUserRole } from "hooks/users"
import Solution from "./components/solution"
import SigmaSolutions from "./components/sigma-solutions"
import { SOLUTIONS, SIGMA_SOLUTIONS } from "./shapes"
import "./style.scss"

function SolutionsModule({
  solutions,
  sigmaSolutions,
  accountAlias,
  isSuperuser,
}) {
  const userRole = useUserRole()

  const showGenericSolutions = (isSuperuser || userRole === "admin") && !!solutions?.length
  const hasSolutionsContent = showGenericSolutions || !!sigmaSolutions?.length

  if (!hasSolutionsContent) {
    return (
      <Alert severity="info" className="modules_solutions-empty">
        No solutions are available for this account.
      </Alert>
    )
  }

  return (
    <div className="modules_solutions">
      <div className="solutions-main">
        <div className="solutions">
          {showGenericSolutions && solutions.map(solution => (
            <Solution key={solution.id} solution={solution} />
          ))}
        </div>
      </div>
      <SigmaSolutions
        sigmaSolutions={sigmaSolutions}
        accountAlias={accountAlias}
        isSuperuser={isSuperuser}
      />
    </div>
  )
}

SolutionsModule.propTypes = {
  solutions: SOLUTIONS.isRequired,
  sigmaSolutions: SIGMA_SOLUTIONS,
  accountAlias: PropTypes.string.isRequired,
  isSuperuser: PropTypes.bool.isRequired,
}

export default SolutionsModule
